<template>
  <div class="registerform__step step__one">
    <div class="step__content">
      <div class="step__headline">
        <h4 class="-color-alpha">Wählen Sie eine der folgenden Möglichkeiten:</h4>
      </div>
      <form class="step__form">
        <div class="form__entry">
          <Entry
            text="Ich überlege ob ich mit einer Wohnmobilvermietung starte und möchte mich unverbindlich informieren"
          @update="updateStep(0)"/>
          <Entry
            text="Ich möchte mit der Vermietung starten und habe noch keine Mietfahrzeuge"
            @update="updateStep(1)"/>
          <Entry
            text="Ich bin bereits Wohnmobil Vermieter"
            @update="updateStep(2)"/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Entry from '../EntryWrapper.vue'
export default {
  name: 'StepOne',
  props: ['registerform', 'privacyPage'],
  components: {
    Entry
  },
  methods: {
    updateStep: function (num) {
      this.registerform.state = num
      this.$emit('updateStep', 'StepTwo')
    }
  }
}
</script>
